import { ref, shallowRef } from "vue";
export function useLogoState(avatarUrl) {
    const pendingLogoFile = shallowRef(null);
    const logoRemoved = ref(false);
    const preModalLogoState = shallowRef(null);
    function handleLogoUpload(file) {
        if (avatarUrl.value?.startsWith("blob:"))
            URL.revokeObjectURL(avatarUrl.value);
        pendingLogoFile.value = file;
        logoRemoved.value = false;
        avatarUrl.value = URL.createObjectURL(file);
        preModalLogoState.value = null;
    }
    function handleLogoRemove() {
        if (!preModalLogoState.value)
            preModalLogoState.value = { file: pendingLogoFile.value, removed: logoRemoved.value, avatarUrl: avatarUrl.value };
        if (avatarUrl.value?.startsWith("blob:"))
            URL.revokeObjectURL(avatarUrl.value);
        pendingLogoFile.value = null;
        logoRemoved.value = true;
        avatarUrl.value = null;
    }
    function handleLogoCancel() {
        const prev = preModalLogoState.value;
        if (!prev)
            return;
        if (avatarUrl.value?.startsWith("blob:"))
            URL.revokeObjectURL(avatarUrl.value);
        pendingLogoFile.value = prev.file;
        logoRemoved.value = prev.removed;
        avatarUrl.value = prev.file ? URL.createObjectURL(prev.file) : prev.avatarUrl;
        preModalLogoState.value = null;
    }
    function resetLogoState() {
        if (avatarUrl.value?.startsWith("blob:"))
            URL.revokeObjectURL(avatarUrl.value);
        pendingLogoFile.value = null;
        logoRemoved.value = false;
        preModalLogoState.value = null;
    }
    return { pendingLogoFile, logoRemoved, preModalLogoState, handleLogoUpload, handleLogoRemove, handleLogoCancel, resetLogoState };
}
